module.exports = __webpack_public_path__ + "img/bg7.46ebdc3d.jpg";